import react, { useState } from 'react'
import { SettingWrapper } from './style'
import { SettingTitleText } from 'src/components/Global/Text/TitleText'
import {
  PrivacyPolicyCard,
  SettingsCard,
} from 'src/components/Global/Cards/Cards'
import {
  SettingsPageData,
  SettingsLogoutData,
  PrivacyPolicyData,
} from './SettingsListData'
import { AvatarUpload } from './AvatarUpload'
import { arrowLeft, inactiveArrow } from 'src/assets'
import { Link, useLocation } from 'react-router-dom'
const SettingsList = () => {
  const [active, setActive] = useState('')
  const ChangeBackgroundColor = (key: any) => {
    setActive(key)
  }

  let location = useLocation()
  return (
    <SettingWrapper>
      <SettingTitleText className="title">Settings</SettingTitleText>
      <div className="profile">
        <div className="profileTexts">
          {SettingsPageData.map((item) => (
            <Link
              to={item.path}
              className="link"
              state={{ backgroundLocation: location }}
              key={item.id}
            >
              <SettingsCard
                onClick={() => setActive(item.class)}
                className={
                  active === item.class ? 'link active' : 'link inactive'
                }
              >
                <div className="list-flex">
                  <div>
                    <img src={item.icon} alt="" />
                  </div>
                  <div className="setitems">
                    <h2>{item.SettingTitle}</h2>
                    <p>{item.SettingsDescription}</p>
                  </div>
                </div>
                <div>
                  <img src={inactiveArrow} alt="" />
                </div>
              </SettingsCard>
            </Link>
          ))}
          {PrivacyPolicyData.map((item) => (
            <a
              href="https://fandksavings.com/privacy"
              target="_blank"
              rel="noreferrer"
              onClick={() => setActive(item.class)}
              className={
                active === item.class ? 'link active' : 'link inactive'
              }
            >
              <SettingsCard>
                <div className="list-flex">
                  <div>
                    <img src={item.icon} alt="" />
                  </div>
                  <div className="setitems">
                    <h2>{item.SettingTitle}</h2>
                    <p>{item.SettingsDescription}</p>
                  </div>
                </div>
                <div>
                  <img src={inactiveArrow} alt="" />
                </div>
              </SettingsCard>
            </a>
          ))}
          {SettingsLogoutData.map((item) => (
            <div
              onClick={() => setActive(item.class)}
              className={
                active === item.class ? 'link active' : 'link inactive'
              }
            >
              <div>
                <Link
                  to={item.path}
                  className="link"
                  state={{ backgroundLocation: location }}
                  key={item.id}
                >
                  <SettingsCard>
                    <div className="list-flex">
                      <div>
                        <img src={item.icon} alt="" />
                      </div>
                      <div className="setitems">
                        <h2 className="log">{item.SettingTitle}</h2>
                        <p>{item.SettingsDescription}</p>
                      </div>
                    </div>
                    <div>
                      <img src={inactiveArrow} alt="" />
                    </div>
                  </SettingsCard>
                </Link>
              </div>
            </div>
          ))}
        </div>
        <div className="profileimg">
          <AvatarUpload />
        </div>
      </div>
    </SettingWrapper>
  )
}

export { SettingsList }
